/**
 * Mira Icon Registry
 *
 */
import {createIconPreloader, createLazyIcon} from 'platform/foundation-tw';
import {z} from 'zod';

export const miraIcons = {
  'mira/engine': createLazyIcon(() => import('./svgs/engine.svg')),
  'mira/question': createLazyIcon(() => import('./svgs/question.svg')),
  'mira/refresh': createLazyIcon(() => import('./svgs/refresh.svg')),
  'mira/screwdriver': createLazyIcon(() => import('./svgs/screwdriver.svg')),
  'mira/wrench': createLazyIcon(() => import('./svgs/wrench.svg')),
  'mira/heating-air-condition': createLazyIcon(() => import('./svgs/heating-air-condition.svg')),
  'mira/transmission': createLazyIcon(() => import('./svgs/transmission.svg')),
  'mira/axles': createLazyIcon(() => import('./svgs/axles.svg')),
  'mira/body-chassis': createLazyIcon(() => import('./svgs/body-chassis.svg')),
  'mira/electric-parts': createLazyIcon(() => import('./svgs/electric-parts.svg')),
  'mira/lightbulb': createLazyIcon(() => import('./svgs/lightbulb.svg')),
  'mira/damage': createLazyIcon(() => import('./svgs/damage.svg')),
  'mira/service': createLazyIcon(() => import('./svgs/service.svg')),
  'mira/suggestions': createLazyIcon(() => import('./svgs/suggestions.svg')),
  'mira/unknown': createLazyIcon(() => import('./svgs/question.svg')),
} as const;

export const MiraIconKeySchema = z.enum([
  'mira/engine',
  'mira/question',
  'mira/refresh',
  'mira/screwdriver',
  'mira/wrench',
  'mira/heating-air-condition',
  'mira/transmission',
  'mira/axles',
  'mira/body-chassis',
  'mira/electric-parts',
  'mira/lightbulb',
  'mira/damage',
  'mira/service',
  'mira/suggestions',
  'mira/unknown',
]);

export type MiraIconKey = z.infer<typeof MiraIconKeySchema>;

const DEFAULT_COMMON_ICONS: readonly MiraIconKey[] = Object.keys(
  miraIcons
) as readonly MiraIconKey[];

// Create generic preloader using foundation utilities
const {preloadIcon, preloadIcons, autoPreloadIcons} = createIconPreloader<MiraIconKey>(
  miraIcons,
  DEFAULT_COMMON_ICONS
);

// Export preload utilities
export {preloadIcon, preloadIcons};

/**
 * Auto-preload commonly used icons during browser idle time
 * Alias for autoPreloadIcons with Mira-specific naming
 *
 * @example
 * ```tsx
 * // In your App.tsx or root component
 * useEffect(() => {
 *   autoPreloadCommonIcons();
 * }, []);
 * ```
 */
export const autoPreloadCommonIcons = autoPreloadIcons;
